var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAreaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 92,
    viewBox: "0 0 89 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.5894,
    cy: 44.7304,
    r: 44.4107,
    fill: "#169E50"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8101 78.4235C25.3713 82.6896 20.0089 85.0643 14.3521 87.1873C12.7141 87.802 13.1897 89.8316 14.933 89.6832L30.9046 88.3243L45.7335 87.4055C46.9583 87.3296 47.2544 85.6592 46.1303 85.1671L28.6188 77.4993C27.8918 77.181 27.0637 77.6716 26.8101 78.4235Z",
    fill: "#169E50",
    stroke: "#169E50",
    strokeWidth: 3.41621
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreaIcon);
export default __webpack_public_path__ + "static/media/areaIcon.cb11c489239258d660e9463d4782d614.svg";
export { ForwardRef as ReactComponent };